import { useAppsByProduct } from '@townsquare/apps-store/hooks';
import { useUserHasCapabilities } from '@townsquare/capability-provider/useUserHasCapabilities';
import { useCollabContext, useRovoWorkspace, useUnitsEnabled } from '@townsquare/collab-context';

export const useProjectsAndGoalsSite = (): {
	cloudId: string | null | undefined;
	hasProjectsAccess: any;
	hasGoalsAccess: any;
} => {
	const products = useAppsByProduct();
	const collabContext = useCollabContext();
	const collabContextCloudIds = collabContext?.collabContextScoping?.collabContextCloudIds ?? [];
	const currentCloudId = useRovoWorkspace();
	const hasGoalsAccess = useUserHasCapabilities(['goals_app:access'], true);
	const hasProjectsAccess = useUserHasCapabilities(['projects_app:access'], true);
	const unitsEnabled = useUnitsEnabled();

	const isUnitFilteringEnabled = unitsEnabled && collabContextCloudIds.length > 0;

	const projectSites = products?.PROJECTS ?? [];
	const goalSites = products?.GOALS ?? [];

	// Unit filtering disabled or current site has projects or goals - use current site capabilities
	if (!isUnitFilteringEnabled || hasGoalsAccess || hasProjectsAccess) {
		return {
			cloudId: hasGoalsAccess || hasProjectsAccess ? currentCloudId : undefined,
			hasProjectsAccess,
			hasGoalsAccess,
		};
	}

	// Fallback to another site in the unit
	const fallbackProject = projectSites.find(site => collabContextCloudIds.includes(site.cloudId));
	const fallbackGoal = goalSites.find(site => collabContextCloudIds.includes(site.cloudId));

	return {
		cloudId: fallbackProject?.cloudId || fallbackGoal?.cloudId,
		hasProjectsAccess: !!fallbackProject,
		hasGoalsAccess: !!fallbackGoal,
	};
};
